import React, { useState } from "react";
import Modal from "components/base/Modal";
import classNames from "classnames";
import css from "../style.scss";
import { useSelector } from 'react-redux';

const NotesNotSaved = ({ isOpen, onClose, onConfirm }) => {

    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                uniqId="EndCampaign"
                width="auto"
                padding="0"
                modalClassName={css.pricingModal}
                className={classNames(css.clsAccPageModals, css.clsBillingModal)}
            >
                <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
                    <div className={classNames(css.clsModalContent, "modal-content")}>
                        <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
                            <div className={css.rbModalTextGroup}>
                                <div className={css.rbModalTitle}>Notes Not Saved</div>
                                <div className={css.rbModalDetails}>
                                    <span>Your notes have not been saved. Please save your  <br></br> changes before continuing.</span>
                                </div>
                            </div>
                            <div className={css.buttonRemoveWrapper}>
                                <button className={css.cancelRemoveBtn} onClick={onClose}>
                                    <span className={css.cancelRemoveLabel}>Do Not Save</span>
                                </button>
                                <button className={classNames(css.connectBtn, { [css.noClick]: isSubmitting })} onClick={onConfirm}>
                                    <span className={css.connectRmvBtnLabel}>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default NotesNotSaved;